import React from 'react';

import { drumPad } from './DrumPads.module.sass';

const DrumPad = () => <div className={drumPad} />;

export default DrumPad;
